import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function LoginNotice ( props ) {

    return <BasicCrudScreenType id="LoginNotice" table="LoginNotice" view="LoginNotice" />;

}

export default LoginNotice;
